import { useInvoicePaymentStatusFilterOptions } from "@/hooks/useEnumOptions";

type InvoiceStatusSelectProps = {
  setStatusField: React.Dispatch<React.SetStateAction<string>>;
  statusField: string;
  options?: {
    label: string;
    value: string;
  }[];
};

export const InvoiceStatusSelect = ({
  setStatusField,
  statusField,
  options,
}: InvoiceStatusSelectProps) => {
  const defaultOptions = useInvoicePaymentStatusFilterOptions();
  return (
    <div className="flex w-fit flex-row rounded-lg border border-gray-200 bg-white p-0.5">
      {(options ?? defaultOptions).map((invoiceStatusOption) => {
        return (
          <button
            key={invoiceStatusOption.value}
            className={`flex flex-row items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold text-gray-700 focus:outline-hidden ${statusField === invoiceStatusOption.value ? "bg-brand700 text-white" : "bg-transparent text-gray-700 hover:text-gray-900"}`}
            onClick={() => setStatusField(invoiceStatusOption.value)}
          >
            {invoiceStatusOption.label}
          </button>
        );
      })}
    </div>
  );
};
